// Fase 2 (W11): Mis asistentes, Aprobar acción, passkeys, panel de uso, papelera y nivel por rol (es).
export const assistentesEs = {
  // Lote 19/10: pantalla de consentimiento del OAuth del MCP.
  oauth: {
    kicker: 'Conexión por OAuth',
    titulo: 'Autorizar el acceso a MalgoOS',
    pedido: '{{cliente}} quiere acceder a MalgoOS en tu nombre',
    cliente: 'Cliente',
    volta: 'Vuelve a',
    registrado: 'Registrado el',
    workspace: 'Workspace',
    empresa: 'Empresa',
    todas: 'Todas las empresas que ves',
    escopos: 'Lo que el cliente puede hacer',
    escoposAjuda: 'Nunca más de lo que tú puedes. Las escrituras sensibles esperan tu confirmación, como en los asistentes, y roles, claves y configuraciones quedan solo contigo.',
    assistente: 'La conexión aparece en Mi cuenta > Mis asistentes, donde ves lo que hizo y puedes revocarla.',
    desligado: 'La conexión por OAuth está desactivada en este workspace. Pide a quien administra que la permita en Integraciones > MCP.',
    aprovar: 'Autorizar',
    recusar: 'Rechazar',
    autorizado: 'Acceso autorizado',
    recusado: 'Acceso rechazado',
    voltando: 'Volviendo a {{cliente}}...',
    erroTitulo: 'No se pudo autorizar',
    erros: {
      cliente_invalido: 'Cliente desconocido. Empieza de nuevo desde la aplicación que pidió el acceso.',
      redirect_invalido: 'La dirección de retorno no es la que registró el cliente. Por seguridad, no se concedió el acceso.',
      pedido_invalido: 'Solicitud de autorización no válida. Empieza de nuevo desde la aplicación que pidió el acceso.',
    },
  },
  aba: 'Mis asistentes',
  titulo: 'Mis asistentes',
  texto: 'Tu asistente de IA trabaja en tu nombre, con como máximo tus permisos. Lo reversible lo hace directamente; lo sensible lo prepara y espera tu confirmación; roles, claves y configuraciones nunca los toca.',
  novo: 'Nuevo asistente',
  vazioTitulo: 'Todavía no tienes asistente',
  vazioTexto: 'Crea un asistente, elige los módulos y los límites y usa su clave en tu agente (MCP).',
  escopoTodos: 'Todos los módulos a los que accedes',
  semChave: 'Sin clave activa',
  nunca: 'Nunca',
  semLimiteCurto: 'Sin tope',
  qualquerHora: 'Cualquier hora',
  verAtividade: 'Lo que hizo',
  novaChave: 'Nueva clave',
  reativar: 'Reactivar',
  revogar: 'Revocar',
  revogado: 'Asistente revocado',
  reativado: 'Asistente reactivado',
  suspenso: 'Asistente suspendido. Reactívalo cuando quieras que vuelva a trabajar.',
  suspensoAnomalia: 'Suspendido por la alerta de comportamiento fuera de lo normal (demasiadas eliminaciones en poco tiempo). Revisa lo que hizo antes de reactivarlo.',
  revogarTitulo: '¿Revocar {{nome}}?',
  revogarTexto: 'La clave deja de valer al instante y las acciones que esperan tu confirmación vencen. No se puede deshacer.',
  novaChaveTitulo: '¿Generar una nueva clave?',
  novaChaveTexto: 'La clave actual deja de valer al instante. Cambia la clave en tu agente enseguida.',
  estados: { ativo: 'Activo', suspenso: 'Suspendido', revogado: 'Revocado' },
  estadosAprovacao: { pendente: 'Esperando por ti', aprovada: 'Aprobada', recusada: 'Rechazada', expirada: 'Vencida', falhou: 'No concluida' },
  campos: {
    chave: 'Clave',
    ultimoUso: 'Último uso',
    hoje: 'Acciones hoy',
    deLimite: '{{n}} de {{limite}}',
    pendentes: 'Esperando por ti',
    valorMaximo: 'Tope por operación',
    horario: 'Horario',
  },
  niveis: { n1: 'lo hace directo', n2: 'pide tu confirmación', n3: 'nunca lo hace' },
  dias: { 0: 'Dom', 1: 'Lun', 2: 'Mar', 3: 'Mié', 4: 'Jue', 5: 'Vie', 6: 'Sáb' },
  chave: {
    titulo: 'Clave del asistente',
    copiar: 'Copiar clave',
    guardei: 'Ya la guardé',
    texto: 'Esta es la única vez que la clave aparece. Guárdala en tu agente ahora; si la pierdes, genera una nueva.',
    como: 'En el agente, usa el servidor MCP en {{url}} con el encabezado Authorization: Bearer seguido de la clave.',
  },
  form: {
    editar: 'Editar {{nome}}',
    criar: 'Crear asistente',
    nome: 'Nombre',
    nomeAjuda: 'Cómo llamas a tu asistente (por ejemplo, Oliv).',
    escopo: 'A qué puede acceder',
    escopoTexto: 'Nunca pasa de tus permisos. Elige solo lo que necesita.',
    todos: 'Todos los módulos a los que accedo',
    semAcesso: 'Sin acceso',
    leitura: 'Solo lectura',
    escrita: 'Lectura y escritura',
    escolhaModulo: 'Elige al menos un módulo',
    confirmacao: 'Confirmación',
    confirmarTudo: 'Pedir mi confirmación también en las acciones reversibles',
    prazo: 'Plazo para que yo confirme',
    horas_one: '{{count}} hora',
    horas_other: '{{count}} horas',
    niveisTitulo: 'Lo que hace solo y lo que pide confirmación',
    niveisTexto: 'Según tu rol. Eliminar, mover dinero, datos personales y envíos externos piden tu confirmación; lo reservado solo lo haces tú, directamente en la pantalla.',
    nenhumaAcao: 'Ninguna acción tuya en este nivel.',
    limites: 'Límites',
    acoesPorDia: 'Acciones por día',
    semLimite: 'En blanco, sin tope.',
    valorMaximo: 'Valor máximo por operación financiera',
    valorInvalido: 'Valor inválido',
    horarioInicio: 'Puede trabajar desde',
    horarioFim: 'Hasta',
    horarioIncompleto: 'Indica el inicio y el fin, o ninguno de los dos',
    dias: 'Días permitidos',
    diasAjuda: 'Ninguno marcado, todos los días.',
    anomaliaExclusoes: 'Alerta: eliminaciones',
    anomaliaJanela: 'En cuántos minutos',
    anomaliaAjuda: 'Pasado ese número de eliminaciones en la ventana, el asistente se suspende y recibes un aviso.',
  },
  atividade: { vazio: 'Todavía no hizo nada.', aprovada: 'Aprobada por ti' },
  pendentes: {
    titulo_one: '{{count}} acción esperando tu confirmación',
    titulo_other: '{{count}} acciones esperando tu confirmación',
    linha: '{{assistente}}: {{acao}} en {{modulo}}',
    expira: 'Vence el {{data}}',
    revisar: 'Revisar',
  },
  uso: {
    titulo: 'Uso del asistente',
    texto: 'Del {{de}} al {{ate}}. Cuenta lo que los asistentes hicieron en tu nombre y lo que hiciste directamente en la pantalla.',
    pessoa: 'Persona',
    eu: '{{nome}} (tú)',
    vazioTitulo: 'Sin uso en el período',
    vazioTexto: 'Cuando el asistente trabaje, los números aparecen aquí.',
    acionamentos: 'Llamadas',
    feitas: 'Acciones hechas por él',
    preparadas: 'Acciones preparadas',
    pendentesAgora_one: '{{count}} esperando ahora',
    pendentesAgora_other: '{{count}} esperando ahora',
    tempoMedio: 'Tiempo hasta la confirmación',
    aprovadas: 'Aprobadas',
    falharam_one: '{{count}} no concluida',
    falharam_other: '{{count}} no concluidas',
    recusadas: 'Rechazadas',
    expiradas: 'Vencidas',
    viaAssistente: 'Por el asistente',
    viaDetalhe: '{{via}} por el asistente, {{direto}} directamente en la pantalla',
    semDado: 'Sin datos',
    modulos: 'Módulos más usados por el asistente',
    semModulos: 'Ningún cambio del asistente en el período.',
    segundos: '{{n}} s',
    minutos: '{{n}} min',
    horas: '{{n}} h',
  },
  lixeira: {
    titulo: 'Deshacer lo que el asistente eliminó',
    texto: 'Eliminaciones de tus asistentes en los últimos 30 días. Deshacer devuelve el registro como estaba.',
    vazioTitulo: 'Nada para deshacer',
    vazioTexto: 'Lo que el asistente elimine aparece aquí durante 30 días.',
    ate: 'Se puede deshacer hasta el {{data}}',
    desfazer: 'Deshacer',
    restaurado: 'Registro recuperado',
  },
  passkeys: {
    titulo: 'Passkeys',
    texto: 'La passkey confirma las acciones sensibles de tu asistente con la biometría de tu dispositivo (Face ID, Touch ID o huella). MalgoOS no guarda tu biometría.',
    nova: 'Nueva passkey',
    novaTexto: 'Ponle un nombre al dispositivo y confirma con tu contraseña. Luego el dispositivo pide la biometría.',
    criar: 'Crear passkey',
    nome: 'Nombre del dispositivo',
    nomeAjuda: 'Por ejemplo, Celular o Portátil.',
    cadastrada: 'Passkey creada',
    cancelada: 'La passkey no se confirmó en el dispositivo. Inténtalo de nuevo.',
    semSuporte: 'Este navegador no acepta passkeys. Usa el código de la app autenticadora para confirmar.',
    vazioTitulo: 'Ninguna passkey',
    vazioTexto: 'Crea una passkey para aprobar con un toque lo que tu asistente prepare.',
    criadaEm: 'Creada el {{data}}',
    usadaEm: 'usada el {{data}}',
    remover: 'Quitar',
    removerNome: 'Quitar la passkey {{nome}}',
    removerTitulo: '¿Quitar la passkey {{nome}}?',
    removerTexto: 'Este dispositivo deja de confirmar las acciones del asistente.',
    removida: 'Passkey quitada',
  },
  aprovar: {
    kicker: 'Asistente',
    titulo: 'Aprobar acción',
    pedido: '{{assistente}} pide tu confirmación',
    modulo: 'Módulo',
    acao: 'Acción',
    valor: 'Valor',
    registro: 'Registro',
    pedidoEm: 'Pedida el',
    expiraEm: 'Vence el',
    decididaEm: 'Decidida el',
    rota: 'Ruta',
    dados: 'Lo que se hará',
    semDados: 'Sin datos además del registro.',
    feita: 'Acción aprobada y hecha',
    feitaTexto: 'La hizo {{assistente}} en tu nombre y está en la auditoría.',
    falhou: 'Aprobada, pero no concluida',
    falhouTexto: 'No se guardó nada.',
    recusada: 'Acción rechazada',
    recusadaTexto: 'No se hizo nada.',
    expirada: 'El plazo venció',
    expiradaTexto: 'La acción no se hizo. Pídela de nuevo al asistente si todavía la necesitas.',
    semPasskey: 'Ninguna passkey registrada. Crea una en Mi cuenta, Seguridad, o usa el código de la app.',
    semConfirmacao: 'Para aprobar, crea una passkey o activa la verificación en dos pasos.',
    irSeguranca: 'Ir a Seguridad',
    recusar: 'Rechazar',
    usarCodigo: 'Usar código de la app',
    aprovarCodigo: 'Aprobar con el código',
    aprovarPasskey: 'Aprobar con passkey',
    recusarTitulo: '¿Rechazar la acción?',
    recusarTexto: '{{assistente}} no hará esta acción.',
    naoEncontrada: 'Aprobación no encontrada',
    naoEncontradaTexto: 'No existe o es de otra persona.',
    irAssistentes: 'Ir a Mis asistentes',
  },
  papel: {
    titulo: 'Nivel de riesgo para los asistentes',
    texto: 'Vale para los asistentes de quien tiene este rol. Cada persona puede endurecer su propio asistente, nunca aflojarlo.',
    travado: 'Reservado a la persona (N3)',
    fabrica: 'Fábrica ({{nivel}})',
  },
};
